import UsersRoleModel from './UsersRoleModel';

/**
 * User model.
 */
export default {
  fields: {
    id: 0,
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    account: null,
    enabled: true,
    roles: [],
    isAdmin: false,
  },
  getDefaults() {
    return JSON.parse(JSON.stringify(this.fields));
  },
  /**
   * Returns completed fields from a response.
   * @param response
   */
  fromApiResponse(response) {
    return {
      id: response.id,
      email: response.email,
      firstName: response.first_name,
      lastName: response.last_name,
      account: response.account,
      enabled: response.is_active,
      password: '',
      roles: response.roles,
      isAdmin: typeof response.roles.find(e => e.id === UsersRoleModel.ROLE_ADMIN) !== 'undefined',
    };
  },
  /**
   * Return an object for sending to a API
   * @param modal
   */
  toApiRequest(model) {
    const data = {
      email: model.email,
      first_name: model.firstName,
      last_name: model.lastName,
      account_id: model.account.id,
      is_active: model.enabled,
    };

    if (model.password.length > 0) {
      data.password = model.password;
    }

    const roles = [UsersRoleModel.ROLE_USER, UsersRoleModel.ROLE_MANAGER];
    if (model.isAdmin === true) {
      roles.push(UsersRoleModel.ROLE_ADMIN);
    }
    data.roles = roles;

    return data;
  },
};
